import React from 'react'
import { useControls } from 'src/components/async/model/control'
import { FilterName, FilterParam } from '../../FilterBar.types'
import { FilterDropdown } from '../FilterDropdown'
import { NONE_VALUE } from '../../FilterBar.constants'

export const DashboardControlFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const { data: controls } = useControls()
  const noControlValue = NONE_VALUE
  const filterValues = [
    noControlValue,
    ...(controls?.getItemsList().map((control) => ({
      label: `${control.getModelId()} ${control.getName()}`,
      value: `${control.getModelId()} ${control.getName()}`,
    })) || []),
  ]

  return (
    <FilterDropdown
      filterParam={FilterParam.DASHBOARD_CONTROL}
      filterName={FilterName.DASHBOARD_CONTROL}
      filterValues={filterValues}
      isNested={isNested}
    />
  )
}
